'use strict';

var cov_v387gr2u7 = function () {
    var path = '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.comments.factory.js',
        hash = '03944df88104556d0bbc1c65c93f9fbcdb38850c',
        global = new Function('return this')(),
        gcv = '__coverage__',
        coverageData = {
        path: '/home/lobo/repos/prospector-app/src/app/shared/js/ORM/tables.comments.factory.js',
        statementMap: {
            '0': {
                start: {
                    line: 1,
                    column: 0
                },
                end: {
                    line: 28,
                    column: 5
                }
            },
            '1': {
                start: {
                    line: 4,
                    column: 4
                },
                end: {
                    line: 6,
                    column: 46
                }
            },
            '2': {
                start: {
                    line: 10,
                    column: 8
                },
                end: {
                    line: 26,
                    column: 11
                }
            },
            '3': {
                start: {
                    line: 23,
                    column: 20
                },
                end: {
                    line: 23,
                    column: 43
                }
            }
        },
        fnMap: {
            '0': {
                name: '(anonymous_0)',
                decl: {
                    start: {
                        line: 1,
                        column: 1
                    },
                    end: {
                        line: 1,
                        column: 2
                    }
                },
                loc: {
                    start: {
                        line: 1,
                        column: 13
                    },
                    end: {
                        line: 28,
                        column: 1
                    }
                },
                line: 1
            },
            '1': {
                name: 'RestmodFactory',
                decl: {
                    start: {
                        line: 9,
                        column: 13
                    },
                    end: {
                        line: 9,
                        column: 27
                    }
                },
                loc: {
                    start: {
                        line: 9,
                        column: 37
                    },
                    end: {
                        line: 27,
                        column: 5
                    }
                },
                line: 9
            },
            '2': {
                name: '(anonymous_2)',
                decl: {
                    start: {
                        line: 22,
                        column: 24
                    },
                    end: {
                        line: 22,
                        column: 25
                    }
                },
                loc: {
                    start: {
                        line: 22,
                        column: 41
                    },
                    end: {
                        line: 24,
                        column: 17
                    }
                },
                line: 22
            }
        },
        branchMap: {},
        s: {
            '0': 0,
            '1': 0,
            '2': 0,
            '3': 0
        },
        f: {
            '0': 0,
            '1': 0,
            '2': 0
        },
        b: {},
        _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
    },
        coverage = global[gcv] || (global[gcv] = {});

    if (coverage[path] && coverage[path].hash === hash) {
        return coverage[path];
    }

    coverageData.hash = hash;
    return coverage[path] = coverageData;
}();

cov_v387gr2u7.s[0]++;
(function () {
    'use strict';

    cov_v387gr2u7.f[0]++;
    cov_v387gr2u7.s[1]++;
    angular.module('app').factory('CommentsTable', RestmodFactory);

    /* @ngInject */
    function RestmodFactory(restmod) {
        cov_v387gr2u7.f[1]++;
        cov_v387gr2u7.s[2]++;

        return restmod.model('/comments').mix('MixinContainable', {
            $config: {
                contains: {
                    user: {
                        type: 'belongsTo',
                        table: 'UsersTable',
                        foreignKey: 'user'
                    }
                }
            },
            created: {
                /* eslint-disable babel/object-shorthand */
                decode: function decode(value) {
                    cov_v387gr2u7.f[2]++;
                    cov_v387gr2u7.s[3]++;

                    return new Date(value);
                }
            }
        });
    }
})();